import { createStore, Store } from "@quotientjs/browser-storage"

import { stringValidator } from "@/stores/utils/validators"

export const PERSON_ID_STORAGE_KEY = "quotient-person-id"

export type PersonId = string

export const PersonIdStore: Store<PersonId, "local"> = createStore({
  key: PERSON_ID_STORAGE_KEY,
  validator: stringValidator,
  storageType: "local",
})
